export default __webpack_public_path__ + "static/media/notification-menu-icon.92b36d4f.svg";